module.exports = __webpack_public_path__ + "img/home_product_card.70dd227a.jpg";